import axios from "axios";
import {URL_SERVER} from "../../../api/config";

export default {
  namespaced: true,
  state: {
    bodegas: [],
    bodega: "",
    sector: "",
    metro: ""
  },
  mutations: {
    "SET_BODEGAS"(state, payload) {
      state.bodegas = payload
    }
  },
  actions: {
    async getMapeo({commit}) {
      try {
        const {data: bodegas} = await axios.get(`${URL_SERVER}v2/mapeo-bodega?sucursal_id[eq]=${window.localStorage.sucursal_id}`)
        commit("SET_BODEGAS", bodegas)
      } catch (e) {
        console.error(e)
      }
    },
    async getMapeoCriteria({commit}, data) {
      let query = Object.keys(data).filter(key => data[key] !== "").map(key => `${key}[eq]=${data[key]}`).join("&")
      if (query !== "") query = `?${query}`
      const {data: bodegas} = await axios.get(`${URL_SERVER}v2/mapeo-bodega${query}`)
      commit("SET_BODEGAS", bodegas)
    }
  },
  getters: {
    bodegas: ({bodegas}) => bodegas
  }
}
